import React from 'react';
import Reveal from 'react-awesome-reveal';

import OwlCarousel from '../../features/owl-carousel';
import BlogTypeOne from '../../features/blogs/blog-type-one';

import { fadeIn } from '../../../utils/data/keyframes';
import { blogSliderModern } from '../../../utils/data/slider';
import useTranslation from '../../../utils/hooks/useTranslation';

export default function BlogSection({ loading, blog }) {
    const { t } = useTranslation();

    return (
        <section className="blog-section-modern">
            <div className="container">
                <div className="section-header">
                    <span className="section-eyebrow">{t('message.from_our_journal')}</span>
                    <h2>{t('message.latest_news')}</h2>
                    <p className="section-subtitle">{t('message.blog_subtitle')}</p>
                </div>

                <OwlCarousel adClass="blog-slider-modern modern-slider owl-theme" options={blogSliderModern}>
                    {loading
                        ? [0, 1, 2].map((item, index) => (
                            <div className="skel-pro skel-pro-grid" key={`blog-skel-${index}`} />
                        ))
                        : blog?.slice(0, 6).map((item, index) => (
                            <Reveal
                                keyframes={fadeIn}
                                delay={100}
                                duration={800}
                                triggerOnce
                                key={`blog-${item.id}`}
                            >
                                <BlogTypeOne blog={item} />
                            </Reveal>
                        ))}
                </OwlCarousel>
            </div>
        </section>
    );
}
